import dayjs from 'dayjs';

import { Label } from '@r1-frontend/ui-react/components/label';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import Widget from '~/src/components/Widget';
import { INDEFINITELY_ACTIVE } from '~/src/features/lk/vases/VasList/widgets/helpers';

interface IProps {
    isActive: boolean,
    activeDate?: string,
    labelText?: string,
}

const LabelAndActivity = ({ isActive, activeDate, labelText }: IProps): JSX.Element | null => {
    const activeToDateChangeFormat = activeDate ? dayjs(activeDate).format('DD.MM.YYYY') : '';

    if (!(labelText || isActive)) {
        return null;
    }

    return (
        <ListContainer $size={8} $wrap={'nowrap'}>
            {labelText && <Label type={'LabelsText_2'}>{labelText}</Label>}
            {isActive && (
                <Widget.PeriodData>
                    {(activeDate === INDEFINITELY_ACTIVE || activeDate === null) ? 'Активна' : `Активна до ${activeToDateChangeFormat}`}
                </Widget.PeriodData>
            )}
        </ListContainer>
    );
};

export default LabelAndActivity;
